import React from 'react';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { formatTimestamp } from '../../../helpers/tablesFuncHelpers';
import '../../../common/MobileGridCards.sass';

const LocationHistoryMobileCard = ({ row }) => {
	const { t } = useTranslation('translation', { keyPrefix: 'reportsPage.standardReportData' });

	const baseData = [
		{ label: t('Time'), value: formatTimestamp(row.time) },
		{ label: t('Address'), value: row.address },
	];

	return (
		<Card className="mobile-grid-card">
			<Card.Body>
				<div className="mobile-card-header">
					<div className="mobile-card-info">
						{baseData.map(({ label, value }) => (
							<div className="mobile-card-info-row" key={label}>
								<span className="label">{label}:</span> <span className="value">{(value === undefined || value === null || value === '') ? 'N/A' : value}</span>
							</div>
						))}
					</div>
				</div>
			</Card.Body>
		</Card>
	);
};

export default LocationHistoryMobileCard;
